import {Routes} from '@src/Constant/routes';
import React from 'react';
import {KeyRouteMap} from '../types';

// Composants publics et généraux
const AppHome = React.lazy(
  () => import('@src/App/components/pages/home/AppHome'),
);
const AppSearch = React.lazy(
  () => import('@src/App/components/pages/Search/AppSearch'),
);
const AppFormPage = React.lazy(
  () => import('@src/App/components/pages/AppFormPage/AppFormPage'),
);
const MenuDrawerContent = React.lazy(
  () => import('@src/layout/AppLayout/AppDrawer/MenuDrawer/MenuDrawerContent'),
);
const PaywallPage = React.lazy(
  () => import('@src/Navigation/PaywallPage/PaywallPage'),
);
const ChoosePlanPage = React.lazy(
  () => import('@src/Navigation/ChoosePlanPage/ChoosePlanPage'),
);
const SuccessPlanPage = React.lazy(
  () =>
    import('@src/Navigation/ChoosePlanPage/SuccessPlanPage/SuccessPlanPage'),
);
const AppVideoPlayer = React.lazy(
  () => import('@src/App/components/pages/VideoPlayer/VideoPlayerPage'),
);
const TermsAndConditions = React.lazy(
  () =>
    import('@src/App/components/pages/TermsAndConditions/TermsAndConditions'),
);
const ComingSoon = React.lazy(
  () => import('@src/App/components/pages/ComingSoon/ComingSoon'),
);
const PromoCodePage = React.lazy(
  () => import('@src/Navigation/PromoCodePage/PromoCodePage'),
);
const AppThankYouPage = React.lazy(
  () => import('@src/App/components/pages/AppThankYouPage/AppThankYouPage'),
);

const emptyRoute = {
  component: React.lazy(() => {
    const EmptyComponent = () => React.createElement('div');
    return Promise.resolve({default: EmptyComponent});
  }),
};

export const publicRoutes: KeyRouteMap = {
  [Routes.HOME]: {component: AppHome},
  [Routes.APP]: {component: AppHome},
  [Routes.SEARCH]: {component: AppSearch},
  [Routes.FORMS]: {component: AppFormPage},
  [Routes.MORE]: {component: MenuDrawerContent},
  [Routes.PAYWALL]: {component: PaywallPage},
  [Routes.CHOOSE_PLAN]: {component: ChoosePlanPage},
  [Routes.SUCCESS_PLAN]: {component: SuccessPlanPage},
  [Routes.WATCH]: {component: AppVideoPlayer},
  [Routes.WATCH_WITH_CTX]: {component: AppVideoPlayer},
  [Routes.TERMS_AND_CONDITION]: {component: TermsAndConditions},
  [Routes.COMING_SOON]: {component: ComingSoon},
  [Routes.PROMOCODE]: {component: PromoCodePage},
  [Routes.THANK_YOU]: {component: AppThankYouPage},
  [Routes.THANK_YOU_MODAL]: emptyRoute,
};
